var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgSign = function SvgSign(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 70 46.26"
  }, props), _path || (_path = React.createElement("path", {
    fill: "currentColor",
    d: "M70 32.69L69.88 0 14.39.05v13.51H0l.12 32.7h55.49v-13.5zM3.78 42.58l-.09-25.34h10.76l.06 15.5h37.37v9.83zM55.5 15.35h-3.68v13.66h-33.7l-.04-25.29h48.14L66.31 29H55.55zm-10.2 0a2.45 2.45 0 11-2.45-2.45 2.45 2.45 0 012.45 2.46zm-8.64 0a2.45 2.45 0 11-2.45-2.45 2.45 2.45 0 012.45 2.46zm-8.64 0a2.45 2.45 0 11-2.45-2.45A2.45 2.45 0 0128 15.36z",
    "data-name": "Layer 2"
  })));
};
export default __webpack_public_path__ + "bff6aef153671e9633e013895c6e00cb.svg";
export { SvgSign as ReactComponent };